module.exports = __webpack_public_path__ + "static/media/union-pay-paymnt-icon-ftr.952bc492.svg";